// orange with icon
var HomeMarker = L.DivIcon.extend({
    options: {
        iconSize:     [33, 37],
        iconAnchor:   [16, 37],
        popupAnchor:  [0, -40],
        className:    'home-marker'
    }
});
// blue
var DefMarker = L.DivIcon.extend({
    options: {
        iconSize:     [33, 37],
        iconAnchor:   [16, 37],
        popupAnchor:  [0, -40],
        className:    'def-marker'
    }
});
// orange
var TopMarker = L.DivIcon.extend({
    options: {
        iconSize:     [33, 37],
        iconAnchor:   [16, 37],
        popupAnchor:  [0, -40],
        className:    'top-marker'
    }
});
// logo
var TopMarkerLogo = L.DivIcon.extend({
    options: {
        iconSize:     [33, 37],
        iconAnchor:   [16, 37],
        popupAnchor:  [0, -40],
        className:    'top-marker-logo'
    }
});